@if (component) {
  <div *ngFor="let item of component.items index as index">
    <span (click)="toggleService.toggle([this.toggleGroupId, index])"
      class="flex flex-middle flex-justify-between p-l p-r p-t-8 p-b-8 cursor-pointer"
      [ngClass]="[component.titleFont || 'h1', 'b-b', 'b-' + (component.borderColor || 'col-4')]">
      <p *iCms="'title' of item"></p>
      <i [toggleClass]="'!icon-chevron-down icon-chevron-up'"
        [toggleClassBy]="toggleService.getState([toggleGroupId,index])"
        class="icon-medium"
        style="font-size: 1.3rem;">
      </i>
    </span>
    @if (item.components) {
      <hide-up
        [open]="[toggleGroupId, index]">
        <icms-outlet [components]="item.components"></icms-outlet>
      </hide-up>
    }
  </div>
}
